import { render, staticRenderFns } from "./role_notification.vue?vue&type=template&id=f1f73af2&scoped=true&"
import script from "./role_notification.vue?vue&type=script&lang=js&"
export * from "./role_notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f73af2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f73af2')) {
      api.createRecord('f1f73af2', component.options)
    } else {
      api.reload('f1f73af2', component.options)
    }
    module.hot.accept("./role_notification.vue?vue&type=template&id=f1f73af2&scoped=true&", function () {
      api.rerender('f1f73af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/row/tabs/role_notification.vue"
export default component.exports